import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { returnToUrlHandler } from "./returnToUrlHandler.ts";
export const LoginScreenPath = "/login";
export function LoginScreen() {
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    loginWithRedirect({
      appState: {
        returnTo: returnToUrlHandler.getReturnToFromUrl(window.location.href),
      },
    }).catch((e) => {
      throw e;
    });
  }, [loginWithRedirect]);
  return null;
}
